import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import clsx from 'clsx'

import Header from '../Header'
import Footer from '../Footer'

function Layout({ sidebar, children }) {
  const {
    allGhostSettings: { nodes: settings },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      allGhostSettings {
        nodes {
          lang
        }
      }
    }
  `)
  const [site] = settings

  return (
    <>
      <Helmet>
        <html lang={site.lang} />
      </Helmet>
      <article
        className={clsx(
          'page-template-default page page-parent et_fixed_nav et_pb_pagebuilder_layout',
          { 'et_right_sidebar et_includes_sidebar': sidebar },
        )}
      >
        <Header />
        <div id="main-content">{children}</div>
        <Footer />
      </article>
    </>
  )
}

Layout.propTypes = {
  sidebar: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

Layout.defaultProps = {
  sidebar: false,
}

export default Layout
